import { ITechnicalsSummaryApi } from "../types/technicals-summary-type.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getTechnicalsSummary = async (exchId: string, formattedSymbol: string) => {
  const response: {
    data: ITechnicalsSummaryApi;
    statusCode: number;
    status: string;
    message: string;
  } = await request({
    method: "GET",
    url: `${API_PATHS.getTechnicalInfo}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });
  return response;
};
